import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import "react-quill/dist/quill.snow.css"
import { useNavigate } from "react-router-dom"
import { Select, Typography, Button } from "antd"
import { Container, Row, Col } from "reactstrap"
import ReactQuill from "react-quill"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { getTerms, updateTerm } from "store/resources/action"
import { useDispatch, useSelector } from "react-redux"
const { Title, Text } = Typography
//i18n
import { withTranslation } from "react-i18next"
const { Option } = Select
const TermsConditions = props => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, termsData } = useSelector(state => state.ResourcesReducer)
  const { currentUser } = useSelector(state => state.Login)
  const [value, setValue] = useState("")

  const handleChange = content => {
    setValue(content)
  }

  useEffect(() => {
    dispatch(getTerms({ id: currentUser.organization_id }))
  }, [])

  useEffect(() => {
    if (termsData?.details) {
      setValue(termsData?.details)
    }
  }, [termsData?.details])

  const handleSaveChanges = () => {
    const payload = {
      id: currentUser.id,
      data: { details: value },
    }
    dispatch(updateTerm(payload))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Dashboard" breadcrumbItem="Terms Conditions" />
          <Row>
            <Col>
              <Title level={3}>Terms Condition</Title>
            </Col>
          </Row>
          <Row>
            <Col>
              <ReactQuill
                value={value}
                onChange={handleChange}
                // theme="snow"
                modules={{ toolbar: true }}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Button
                className="bg-primary w-xl text-white"
                style={{
                  float: "right",
                }}
                onClick={handleSaveChanges}
                disabled={loading}
              >
                Save Changes
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

TermsConditions.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(TermsConditions)
